// src/routes/AppRoutes.js
import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import Home from './pages/Home';
import AppLogin from './pages/AppLogin';
import Profile from './pages/Profile';
import Config from './pages/Config';
import ChangePass from './pages/ChangePass';
import OpdDash from './pages/OpdDash';
import IpdDash from './pages/IpdDash';
import Doctors from './pages/Doctors';
import Staff from './pages/Staff';
import Departments from './pages/Departments';
import Specalities from './pages/Specalities';
import Wards from './pages/Wards';
import Beds from './pages/Beds';
import Charges from './pages/Charges';
import Services from './pages/Services';
import TpaList from './pages/TpaList';
import TestCats from './pages/TestCats';
import SetCats from './pages/SetCats';
import EmailSetup from './pages/EmailSetup';
//import WhatSetup from './pages/WhatSetup';
import SmsSetup from './pages/SmsSetup';
import Labs from './pages/Labs';
import RadioLabs from './pages/RadioLabs';
import LabReports from './pages/LabReports';
import RedReports from './pages/RedReports';
import Invoices from './pages/Invoices';
import OtPage from './pages/OtPage';
import Medicines from './pages/Medicines';
import Sales from './pages/Sales';
import Purchases from './pages/Purchases';
import Suppliers from './pages/Suppliers';
import Reports from './pages/Reports';
import GstDetails from './pages/GstDetails';
import ChangePassword from './pages/ChangePassword';
import Settings from './pages/Settings';
import OwnProfile from './pages/OwnProfile';
import HospProfile from './pages/HospProfile';
import PharmaProfile from './pages/PharmaProfile';
import Nurses from './pages/Nurses';
import ManageSign from './pages/ManageSign';
import PkgMaster from './pages/PkgMaster';
import Vitals from './pages/Vitals';
import HospitalCharges from './pages/HospitalCharges';
import TestCategories from './pages/TestCategories';
import Registrations from './pages/Registrations';
import TestDetailes from './pages/TestDetailes';
import TestParams from './pages/TestParams';
import ReportEntry from './pages/ReportEntry';
import MyReports from './pages/MyReports';
import OpdRegistrations from './pages/OpdRegistrations';
import IpdRegistrations from './pages/IpdRegistrations';
import IpdBilling from './pages/IpdBilling';
import IpdPataintList from './pages/IpdPataintList';
import OtManagement from './pages/OtManagement';
import DisList from './pages/DisList';
import BedDetails from './pages/BedDetails';
import PharamaReports from './pages/PharamaReports';
import Hsn from './pages/Hsn';
import Units from './pages/Units';
import StoreDepartments from './pages/StoreDepartments';
import ItemMaster from './pages/ItemMaster';
import Supplier from './pages/Supplier';
import StorePurchase from './pages/StorePurchase';
import PurchaseReturns from './pages/PurchaseReturns';
import StoreSales from './pages/StoreSales';
import SaleReturn from './pages/SaleReturn';
import PurchaseReturn from './pages/PurchaseReturn';
import Stocks from './pages/Stocks';
import TprSheet from './pages/TprSheet';
import MedSheet from './pages/MedSheet';
import Ambulance from './pages/Ambulance';
import AddEmp from './pages/AddEmp';
import EmpList from './pages/EmpList';
import WhatsappSetup from './pages/WhatsappSetup';
import BillType from './pages/BillType';
import SmsMaster from './pages/SmsMaster';
import TpaWorkload from './pages/TpaWorkload';
import TarifRate from './pages/TarifRate';
import TpaAdvRec from './pages/TpaAdvRec';
import TpaFinRec from './pages/TpaFinRec';
import TpaPayment from './pages/TpaPayment';
import TpaVoucher from './pages/TpaVoucher';
import TpaMaster from './pages/TpaMaster';
import AddOt from './pages/AddOt';
import MedCats from './pages/MedCats';
import AddPurchase from './pages/AddPurchase';
import AddPurchase1 from './pages/AddPurchase1';
import AddSale from './pages/AddSale';
import AddSale1 from './pages/AddSale1';
import GstDetails1 from './pages/GstDetails1';
import MediCert from './pages/MediCert';
import BirthCert from './pages/BirthCert';
import DeathCert from './pages/DeathCert';
import PharmaReports from './pages/PharmaReports';
import IpdReports from './pages/IpdReports';
import OpdReports from './pages/OpdReports';
import AddSale2 from './pages/AddSale2';
import AddSale3 from './pages/AddSale3';
import LabRegistrations from './pages/LabRegistrations';
import OpdPataintList from './pages/OpdPataintList';
import NewPurchase from './pages/NewPurchase';
import NewSaleReturn from './pages/NewSaleReturn';
import StoreSaleReturn from './pages/StoreSaleReturn';
import LabRepView from './pages/LabRepView';
import Cases from './pages/Case';
import PurchaseReturn2 from './pages/PurchaseReturn2';
import DischargeSummary from './pages/AddDischarge';
import Registration from './pages/emergency_reg';
import Sample_Collection from './pages/sample_collection';
import RoleBaseModel from './pages/roleBaseModel';
import Accounts from './pages/all_accounts_reports';
import Expense from './pages/expenses';
import TPA_List from './pages/tpa_reg';
import Insurance_List from './pages/insur_reg';
import Doctor_Accounts from './pages/doctorref';
import Patient_History from './pages/patienthis';
import Broker from './pages/broker_list';
import Broker_Accounts from './pages/broker_accounts';
import Stock_Expiry_Reports from './pages/stock_reports';
import GST_Reports from './pages/gst_report';
import OPD_Digital_Prescription from './pages/opd_prescription';
import Patient_List from './pages/emergency_list';
import RenewalPage from './pages/Renewalpage';



const AppRoutes = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const ldata = sessionStorage.getItem("ldata");
    const lastSegment = window.location.pathname.split('/');
    const isAtLogin = lastSegment[lastSegment.length - 1].localeCompare("login") === 0;

    if (isAtLogin) {
      if (ldata && ldata.length > 0) {
        // Already logged in -> go to root (client-side)
        navigate("/", { replace: true });
      }
    } else {
      // Not at login and not logged in -> redirect to login (client-side)
      if (!ldata || ldata.length <= 0) {
        navigate("/login", { replace: true });
      }
    }
  }, [navigate]);
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/lab_reports" element={<LabReports />} />
      <Route path="/lab_patient_list" element={<LabRegistrations />} />
      
      <Route path="/opd_reports" element={<OpdReports />} />
      <Route path="/ipd_reports" element={<IpdReports />} />
      <Route path="/pharma_reports" element={<PharmaReports />} />
      <Route path="/config" element={<Config />} />
      <Route path="/login" element={<AppLogin />} />
      <Route path="/medicine_cats" element={<MedCats />} />
      <Route path="/add_purchase" element={<AddPurchase />} />
      <Route path="/new_purchase" element={<NewPurchase />} />
      <Route path="/add_purchase1" element={<AddPurchase1 />} />
      <Route path="/new_sale" element={<AddSale />} />
      <Route path="/new_sale_return" element={<NewSaleReturn />} />
      <Route path="/pharmacy_sale" element={<AddSale2 />} />
      <Route path="/sales_Return" element={<AddSale3 />} />
      <Route path="/new_sale1" element={<AddSale1 />} />
      <Route path="/gst_details" element={<GstDetails />} />
      <Route path="/gst_details1" element={<GstDetails1 />} />
      <Route path="/medical_certificate" element={<MediCert />} />
      <Route path="/birth_certificate" element={<BirthCert />} />
      <Route path="/death_certificate" element={<DeathCert />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/change_password" element={<ChangePassword />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/own_profile" element={<OwnProfile />} />
      <Route path="/hosp_profile" element={<HospProfile />} />
      <Route path="/pharma_profile" element={<PharmaProfile />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/specalities" element={<Specalities />} />
      <Route path="/doctors" element={<Doctors />} />
      <Route path="/authorisation" element={<RoleBaseModel />} />
      <Route path="/nurses" element={<Nurses />} />
      <Route path="/wards" element={<Wards />} />
      <Route path="/beds" element={<Beds />} />
      <Route path="/case" element={<Cases />} />
      <Route path="/manage_sign" element={<ManageSign />} />
      <Route path="/pkg_master" element={<PkgMaster />} />
      <Route path="/vitals" element={<Vitals />} />
      <Route path="/hospital_charges" element={<HospitalCharges />} />
      <Route path="/services" element={<Services />} />
      <Route path="/test_categories" element={<TestCategories />} />
      <Route path="/registrations" element={<Registrations />} />
      <Route path="/test_detailes" element={<TestDetailes />} />
      <Route path="/test_params" element={<TestParams />} />
      <Route path="/report_entry" element={<ReportEntry />} />
      <Route path="/my_reports" element={<MyReports />} />
      <Route path="/opd_registrations" element={<OpdRegistrations />} />
      <Route path="/ipd_registrations" element={<IpdRegistrations />} />
      <Route path="/ipd_billing" element={<IpdBilling />} />
      <Route path="/ipd_pataint_list" element={<IpdPataintList />} />
      <Route path="/opd_patient_list" element={<OpdPataintList />} />
      <Route path="/lab_report/:reportID" element={<LabRepView />} />
      <Route path="/ot_management" element={<OtManagement />} />
      <Route path="/dis_list" element={<DisList />} />
      <Route path="/bed_details" element={<BedDetails />} />
      <Route path="/medicines" element={<Medicines />} />
      <Route path="/sales" element={<Sales />} />
      <Route path="/tpa_list" element={<TpaList />} />
      <Route path="/add_ot" element={<AddOt />} />
      
      <Route path="/purchases" element={<Purchases />} />
      <Route path="/suppliers" element={<Suppliers />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/pharama_reports" element={<PharamaReports />} />
      <Route path="/hsn" element={<Hsn />} />
      <Route path="/units" element={<Units />} />
      <Route path="/store_departments" element={<StoreDepartments />} />
      <Route path="/item_master" element={<ItemMaster />} />
      <Route path="/supplier" element={<Supplier />} />
      <Route path="/store_purchase" element={<StorePurchase />} />
      <Route path="/purchase_returns" element={<PurchaseReturns />} />
      <Route path="/store_sales" element={<StoreSales />} />
      <Route path="/sale_return" element={<SaleReturn />} />
      <Route path="/sale_return1" element={<StoreSaleReturn />} />
      <Route path="/purchase_return" element={<PurchaseReturn />} />
      <Route path="/purchase_return2" element={<PurchaseReturn2 />} />
      <Route path="/stocks" element={<Stocks />} />
      <Route path="/gst_details" element={<GstDetails />} />
      <Route path="/tpr_sheet" element={<TprSheet />} />
      <Route path="/med_sheet" element={<MedSheet />} />
      <Route path="/ambulance" element={<Ambulance />} />
      <Route path="/add_emp" element={<AddEmp />} />
      <Route path="/emp_list" element={<EmpList />} />
      <Route path="/whatsapp_setup" element={<WhatsappSetup />} />
      <Route path="/bill_type" element={<BillType />} />
      <Route path="/sms_setup" element={<SmsSetup />} />
      <Route path="/email_setup" element={<EmailSetup />} />
      <Route path="/sms_master" element={<SmsMaster />} />
      <Route path="/tpa_workload" element={<TpaWorkload />} />
      <Route path="/tarif_rate" element={<TarifRate />} />
      <Route path="/tpa_adv_rec" element={<TpaAdvRec />} />
      <Route path="/tpa_fin_rec" element={<TpaFinRec />} />
      <Route path="/tpa_payment" element={<TpaPayment />} />
      <Route path="/tpa_voucher" element={<TpaVoucher />} />
      <Route path="/tpa_master" element={<TpaMaster />} />
      <Route path="/discharge-summary" element={<DischargeSummary />} />
      

      <Route path="/emergency_reg" element={<Registration />} />
      <Route path="/sample_collection" element={<Sample_Collection />} />
      
      <Route path="/all_accounts_reports" element={<Accounts/>} />
      <Route path="/expenses" element={<Expense/>} />
      <Route path="/insur_reg" element={<Insurance_List/>} />

      <Route path="/tpa_reg" element={<TPA_List/>} />

      <Route path="/doctorref" element={<Doctor_Accounts/>} />
      <Route path="/patienthis" element={<Patient_History/>} />

      <Route path="/broker_list" element={<Broker/>} />
      <Route path="/broker_accounts" element={<Broker_Accounts/>} />
      <Route path="/stock_reports" element={<Stock_Expiry_Reports/>} />
      <Route path="/gst_report" element={<GST_Reports/>} />
      <Route path="/opd_prescription" element={<OPD_Digital_Prescription/>} />
      <Route path="/emergency_list" element={<Patient_List/>} />
      <Route path="/renewal" element={<RenewalPage />} />
      
      <Route path="*" element={<h2>404 Not Found</h2>} />
    </Routes>
  );
};

export default AppRoutes;
